import requests from './requests';

export default {
    get(hash) {
        return requests.get(`/trainer/share/${hash}`)
            .then(resp => resp.data);
    },
    getCourse(hash) {
        return requests.get(`/trainer/share/${hash}/course`)
            .then(resp => resp.data);
    },
    getTimes(hash) {
        return requests.get(`/trainer/share/${hash}/times`)
            .then(resp => resp.data);
    },
    bind(hash) {
        return requests.post(`/trainer/share/${hash}/bind`)
            .then(resp => resp.data);
    },
    request(hash, payload) {
        return requests.post(`/trainer/share/${hash}/request`, payload)
            .then(resp => resp.data);
    },
};



// WEBPACK FOOTER //
// ./src/api/share.js